import React, { memo } from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

const ListItem = memo(function ListItem({
  to,
  icon,
  title,
  subtitle,
  badge,
  right,
  onClick,
  className = "",
}) {
  const Comp = to ? Link : "button";

  return (
    <Comp
      to={to}
      onClick={onClick}
      className={`
        group
        w-full
        rounded-[20px]
        border border-slate-200/70 dark:border-slate-700/60
        bg-white dark:bg-slate-800
        p-3.5
        text-left
        shadow-sm
        transition-[transform,box-shadow,border-color]
        duration-200
        ease-out
        hover:shadow-md
        hover:border-slate-300/60 dark:hover:border-slate-600/60
        active:scale-[0.98]
        ${className}
      `}
    >
      <div className="flex items-center gap-3">

        {/* 🔥 ICON */}
        {icon && (
          <div
            className="
              h-11 w-11
              shrink-0
              rounded-[14px]
              bg-[#e8f0fb] dark:bg-brand/15
              border border-[#d7e5f8] dark:border-brand/20
              flex items-center justify-center
              text-brand
              shadow-sm
            "
          >
            {icon}
          </div>
        )}

        {/* 🔥 CONTENT */}
        <div className="flex-1 min-w-0">

          <div className="flex items-center gap-2">
            <p className="text-[14px] font-semibold tracking-tight text-slate-900 dark:text-slate-100 truncate">
              {title}
            </p>

            {badge}
          </div>

          {subtitle && (
            <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400 truncate leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>

        {/* 🔥 RIGHT */}
        {right ? (
          <div className="shrink-0">
            {right}
          </div>
        ) : (
          <ChevronRight
            size={16}
            className="
              shrink-0
              text-slate-300/70 dark:text-slate-600
              transition-[transform,color]
              duration-200
              ease-out
              group-hover:text-slate-500 dark:group-hover:text-slate-400
              group-hover:translate-x-0.5
            "
          />
        )}
      </div>
    </Comp>
  );
});

export default ListItem;